import { gql } from "@apollo/client";

export const SystemIoTConnectionStatus = gql`
    query SystemIoTConnectionStatus($id: ID!) {
        system(id: $id) {
            id
            iotConnection {
                id
                connectionStatus
            }
        }
    }
`;

/**
 * When the backend's network lookup fails for a device it silently nulls the
 * WHOLE iotConnection (no errors entry — e.g. system 60 on testing, 2026-10-09).
 * Every consumer must use fetchPolicy "no-cache", or the null clobbers the cached
 * connection of SystemIotConnection/SystemDashboardHero and the dashboard flips
 * between connected and unconnected in an endless refetch loop.
 */
export const SystemNetworkInfo = gql`
    query SystemNetworkInfo($id: ID!) {
        system(id: $id) {
            id
            iotConnection {
                id
                networkInformation {
                    networkProvider
                    currentStandard
                    signalStrength
                }
            }
        }
    }
`;
